module.exports = __webpack_public_path__ + "img/blueLocation.898e4591.svg";